import { useSelector } from 'react-redux';
import reducer from './rootReducer';
import { initialState } from './initialState';
import _ from 'lodash';
export const rootReducer = reducer;
export type AppState = typeof initialState;

export { default as createStore } from './createStore';

export const useRedux = <K extends keyof AppState>(key: K) => useSelector((state: AppState) => state[key]);
export const useStore = () => useSelector((state: AppState) => state);
export const useReduxLoading = <K extends keyof Omit<AppState, 'snacks'>>(...keys: K[]) =>
  useSelector((state: AppState) => keys.some((key) => state[key].isLoading || state[key].isInitLoading));


